"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuperUpgrader__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "adminRole",
                type: "address",
            },
            {
                internalType: "address[]",
                name: "backendAddr",
                type: "address[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "OptinAutoUpgrade",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "OptoutAutoUpgrade",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "previousAdminRole",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "newAdminRole",
                type: "bytes32",
            },
        ],
        name: "RoleAdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleGranted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleRevoked",
        type: "event",
    },
    {
        inputs: [],
        name: "BACKEND_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DEFAULT_ADMIN_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getBackendAgents",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleAdmin",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "getRoleMember",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleMemberCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "grantBackendAgent",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "grantRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "hasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "isBackendAgent",
        outputs: [
            {
                internalType: "bool",
                name: "yes",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "optinAutoUpgrades",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "optoutAutoUpgrades",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "renounceRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "revokeBackendAgent",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "revokeRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "superTokenAddr",
                type: "address",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "upgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class SuperUpgrader__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(adminRole, backendAddr, overrides) {
        return super.deploy(adminRole, backendAddr, overrides || {});
    }
    getDeployTransaction(adminRole, backendAddr, overrides) {
        return super.getDeployTransaction(adminRole, backendAddr, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.SuperUpgrader__factory = SuperUpgrader__factory;
SuperUpgrader__factory.bytecode = _bytecode;
SuperUpgrader__factory.abi = _abi;
//# sourceMappingURL=SuperUpgrader__factory.js.map